/**
 * MemorizationScreen Component
 * Displays memorization phase content
 */
import React from 'react';
import Timer from '../Timer';

interface MemorizationScreenProps {
  content: string;
  duration: number;
  questionId: string;
  onComplete: () => void;
}

export const MemorizationScreen: React.FC<MemorizationScreenProps> = ({
  content,
  duration,
  questionId,
  onComplete
}) => (
  <div className="min-h-screen bg-neutral flex items-center justify-center p-4">
    <div className="bg-white rounded-xl shadow-xl p-6 max-w-xl w-full">
      <h2 className="text-2xl font-bold text-primary mb-4">Phase de mémorisation</h2>
      
      {duration > 0 && (
        <div className="mb-4">
          <Timer 
            duration={duration} 
            onComplete={onComplete}
            key={`memorization-${questionId}`}
          />
        </div>
      )}
      
      <div className="bg-yellow-50 border-2 border-yellow-300 rounded-lg p-6 mb-5">
        <p className="text-gray-800 text-xl font-mono whitespace-pre-line text-center">
          {content}
        </p>
      </div>
      
      <p className="text-gray-500 text-sm text-center mb-4">
        Mémorisez bien ces informations avant de continuer
      </p>
      
      <button
        onClick={onComplete}
        className="w-full bg-secondary hover:bg-opacity-90 text-white font-bold py-3 rounded-lg text-base transition"
      >
        J'ai mémorisé, continuer
      </button>
    </div>
  </div>
);

export default MemorizationScreen;
